import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MomentModule } from 'angular2-moment';
import { BusyModule } from 'angular2-busy';
import { CountoModule } from 'angular2-counto';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgSlimScrollModule } from "../../../node_modules/ngx-slimscroll/src/ngx-slimscroll/module/ngx-slimscroll.module";

import { BrightServeModule } from "app/brightserve/brightserve.module";
import { SharedModule } from "app/shared/shared.module";

import { DashboardService } from "./dashboard.service";
import { CasePipe } from './pipes/case.pipe';

import { DashboardComponent } from "./dashboard.component";
import { AuthGuard } from "app/brightserve/auth-guard";

const DashboardRoutes: Routes = [
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(DashboardRoutes),
        NgbModule,
        MomentModule,
        BrightServeModule,
        SharedModule,
        BusyModule,
        CountoModule,
        InfiniteScrollModule,
        NgSlimScrollModule
    ],
    declarations: [
        DashboardComponent,
        CasePipe
    ],
    providers: [
        DashboardService
    ]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.module.ts